import React, { useEffect, useState } from "react";
import SessionBlocks from "@/components/SessionBlocks";
import { getTiles, getTile, getSessionContent, getUi } from "@/portal/portal";

function List({ title, items, testid }) {
  return (
    <div className="rbl-feature" data-testid={testid}>
      <h3>{title}</h3>
      <ul style={{ margin: 0, paddingLeft: 18 }}>{items.map((x, i) => <li key={i} style={{ marginBottom: 6 }}>{x}</li>)}</ul>
    </div>
  );
}

export function Part2Overview({ ov, t }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16, marginTop: 18 }} data-testid="p2-overview">
      <List title={t("ovGoals")} items={ov.goals} testid="p2-ov-goals" />
      <List title={t("ovTopics")} items={ov.topics} testid="p2-ov-topics" />
      <List title={t("ovTheory")} items={ov.theory} testid="p2-ov-theory" />
      <List title={t("ovExercises")} items={ov.exercises} testid="p2-ov-exercises" />
    </div>
  );
}

function Part1SessionModal({ n, sessions, lang, meta, onNav, onClose, t }) {
  const tile = getTile(lang, n);
  const idx = sessions.indexOf(n);
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", esc);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", esc); document.body.style.overflow = ""; };
  }, [onClose]);
  return (
    <div className="rbl-modal-bg" onClick={onClose} data-testid="p2-recap-modal">
      <div className="rbl-drawer" style={{ maxWidth: 980 }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
          <div className="rbl-sess-eyebrow">{t("navPart1")} · {String(n).padStart(2, "0")}</div>
          <button className="rbl-btn" onClick={onClose} data-testid="p2-recap-close" style={{ padding: "8px 14px", fontSize: 13, whiteSpace: "nowrap", flexShrink: 0 }}>✕ {t("backToDay")}</button>
        </div>
        <h2 className="rbl-sess-title" style={{ fontSize: 30 }}>{tile.icon} {tile.title}</h2>
        <div className="rbl-sess-sub">{tile.subtitle}</div>
        <SessionBlocks sections={getSessionContent(lang, n)} sessionMeta={meta?.[n]} t={getUi(lang)} />
        <div className="rbl-sess-nav">
          {idx > 0 ? <button className="rbl-link" style={{ border: "none", background: "none" }} data-testid="p2-recap-prev" onClick={() => onNav(sessions[idx - 1])}>← {String(sessions[idx - 1]).padStart(2, "0")}</button> : <span />}
          {idx < sessions.length - 1
            ? <button className="rbl-btn" data-testid="p2-recap-next" onClick={() => onNav(sessions[idx + 1])}>{String(sessions[idx + 1]).padStart(2, "0")} →</button>
            : <button className="rbl-btn green" data-testid="p2-recap-done" onClick={onClose}>{t("backToDay")}</button>}
        </div>
      </div>
    </div>
  );
}

export function Part1Recap({ lang, t, sessions, meta }) {
  const [open, setOpen] = useState(null);
  const tiles = getTiles(lang).filter((s) => !sessions || sessions.includes(s.number));
  const nav = (n) => { setOpen(n); document.querySelector("[data-testid=p2-recap-modal] .rbl-drawer")?.scrollTo(0, 0); };
  return (
    <>
      <div className="rbl-grid" style={{ marginTop: 12 }} data-testid="p2-part1-recap">
        {tiles.map((s) => (
          <button type="button" className="rbl-card" key={s.number} data-testid={`p2-recap-${s.number}`} onClick={() => setOpen(s.number)} style={{ textAlign: "left", font: "inherit" }}>
            <span className="rbl-card-num">{String(s.number).padStart(2, "0")}</span>
            <span className="rbl-card-emoji">{s.icon}</span>
            <span className="rbl-card-title">{s.title}</span>
            <span className="rbl-card-meta">{s.subtitle}</span>
            <span className="rbl-card-cta">{t("recapOpen")} →</span>
          </button>
        ))}
      </div>
      {open && <Part1SessionModal n={open} sessions={tiles.map((s) => s.number)} lang={lang} meta={meta} t={t} onNav={nav} onClose={() => setOpen(null)} />}
    </>
  );
}
